import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IWeekDayTime } from 'app/shared/model/week-day-time.model';
import { getEntities as getWeekDayTimes } from 'app/entities/week-day-time/week-day-time.reducer';
import { IWeekDayTimeAvailability } from 'app/shared/model/week-day-time-availability.model';
import { getEntity, updateEntity, createEntity, reset } from './week-day-time-availability.reducer';

export const WeekDayTimeAvailabilityUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const weekDayTimes = useAppSelector(state => state.weekDayTime.entities);
  const weekDayTimeAvailabilityEntity = useAppSelector(state => state.weekDayTimeAvailability.entity);
  const loading = useAppSelector(state => state.weekDayTimeAvailability.loading);
  const updating = useAppSelector(state => state.weekDayTimeAvailability.updating);
  const updateSuccess = useAppSelector(state => state.weekDayTimeAvailability.updateSuccess);

  const handleClose = () => {
    navigate('/week-day-time-availability' + location.search);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getWeekDayTimes({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...weekDayTimeAvailabilityEntity,
      ...values,
      weekDayTime: weekDayTimes.find(it => it.id.toString() === values.weekDayTime.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...weekDayTimeAvailabilityEntity,
          weekDayTime: weekDayTimeAvailabilityEntity?.weekDayTime?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="activitiesApp.weekDayTimeAvailability.home.createOrEditLabel" data-cy="WeekDayTimeAvailabilityCreateUpdateHeading">
            <Translate contentKey="activitiesApp.weekDayTimeAvailability.home.createOrEditLabel">
              Create or edit a WeekDayTimeAvailability
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="week-day-time-availability-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('activitiesApp.weekDayTimeAvailability.adultCount')}
                id="week-day-time-availability-adultCount"
                name="adultCount"
                data-cy="adultCount"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.weekDayTimeAvailability.childCount')}
                id="week-day-time-availability-childCount"
                name="childCount"
                data-cy="childCount"
                type="text"
              />
              <ValidatedField
                label={translate('activitiesApp.weekDayTimeAvailability.infantCount')}
                id="week-day-time-availability-infantCount"
                name="infantCount"
                data-cy="infantCount"
                type="text"
              />
              <ValidatedField
                id="week-day-time-availability-weekDayTime"
                name="weekDayTime"
                data-cy="weekDayTime"
                label={translate('activitiesApp.weekDayTimeAvailability.weekDayTime')}
                type="select"
              >
                <option value="" key="0" />
                {weekDayTimes
                  ? weekDayTimes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.weekDay}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/week-day-time-availability" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default WeekDayTimeAvailabilityUpdate;
